import script from "./ImpactStories.vue?vue&type=script&setup=true&lang=js"
export * from "./ImpactStories.vue?vue&type=script&setup=true&lang=js"

import "./ImpactStories.vue?vue&type=style&index=0&id=16b52e78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16b52e78"]])

export default __exports__